import './hero.css';

import ImageCarousel from '../hero-carousel';
import React from 'react';

const Hero = ({ content }) => {
	return (
		<>
			<ImageCarousel content={content} />
		</>
	);
};

export default Hero;

